import "core-js/modules/es.string.link.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("main", [_c("a-form", {
    attrs: {
      form: _vm.form
    }
  }, [_c("CardItem", {
    attrs: {
      layout: "vertical"
    }
  }, [_c("Title", {
    attrs: {
      type: "input"
    },
    model: {
      value: _vm.value.title,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "title", $$v);
      },
      expression: "value.title"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: "链接",
      layout: "vertical"
    }
  }, [_c("a-textarea", {
    attrs: {
      rows: "5"
    },
    model: {
      value: _vm.rightCom.link,
      callback: function callback($$v) {
        _vm.$set(_vm.rightCom, "link", $$v);
      },
      expression: "rightCom.link"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: "图片",
      layout: "vertical"
    }
  }, [_c("FileUpload", {
    attrs: {
      list: _vm.list
    },
    on: {
      success: function success(val) {
        return _vm.handleImgSuccess(val);
      },
      delete: _vm.handleImg
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: "一级菜单字体色"
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.firstColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "firstColor", $$v);
      },
      expression: "value.firstColor"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: "一级菜单选中颜色"
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.firstCheckColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "firstCheckColor", $$v);
      },
      expression: "value.firstCheckColor"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: "文本大小",
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 12,
      max: 80,
      suffix: "px"
    },
    model: {
      value: _vm.value.textSize,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "textSize", $$v);
      },
      expression: "value.textSize"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };